// Enable via .env.local file: "VITE_PROXY_API: <url>"
const proxySelfServiceApi = import.meta.env.DEV && Boolean(import.meta.env.VITE_PROXY_API);
const remoteEnv = (import.meta.env.DEV ? import.meta.env.VITE_REMOTE_ENV : undefined) as Environments | undefined;

const domainEnvMap = {
  localhost: 'local',
  'minside.dev.rikstv.no': 'dev',
  'minside.uat.rikstv.no': 'uat',
  'minside.rikstv.no': 'prod',
} as const;
type Domains = keyof typeof domainEnvMap;
type Environments = (typeof domainEnvMap)[Domains];
type EnvVariations<T = string> = Record<Environments, T>;
class ConfigEnvs {
  readonly env: Environments;
  constructor(env: Environments) {
    this.env = env;
  }
  forEnv<T>(variations: EnvVariations<T>) {
    return variations[this.env];
  }
  forEnvWithDefault<T>(variations: Partial<EnvVariations<T>> & { default: T }) {
    return this.forEnv(variations as EnvVariations<T>) ?? variations.default;
  }
}
const getConfig = () => {
  const validOverride = (remoteEnv != null && Object.values(domainEnvMap).includes(remoteEnv)) ?? false;
  const env = validOverride
    ? (remoteEnv as Environments)
    : domainEnvMap[location.hostname as keyof typeof domainEnvMap] || 'prod';
  const envConf = new ConfigEnvs(env);

  return {
    environment: env,
    apiBaseUrl: envConf.forEnvWithDefault(
      proxySelfServiceApi
        ? {
            default: `/api`,
          }
        : {
            dev: `https://api-selfservice.dev.rikstv.no`,
            prod: `https://api-selfservice.rikstv.no`,
            default: `https://api-selfservice.uat.rikstv.no`,
          },
    ),
    tvodApiBaseUrl: envConf.forEnvWithDefault({
      prod: `https://tvod.rikstv.no/1`,
      default: `https://tvod.uat.rikstv.no/1`,
    }),
    stsConfig: {
      appUrl: location.origin,
      authority: envConf.forEnvWithDefault({
        prod: 'https://login.rikstv.no/3',
        default: `https://login.uat.rikstv.no/3`,
      }),
      clientId: 'no.rikstv.minside',
      scope: 'openid urn:rikstv:app',
      post_logout_redirect_uri: location.origin.replace('minside.', ''),
    },
    websocketServer: envConf.forEnvWithDefault({
      prod: `https://ws.rikstv.no:443/companion`,
      default: `https://ws.uat.rikstv.no:443/companion`,
    }),
    cmsConfig: {
      projectId: 'bj7ifs6s',
      dataset: envConf.forEnvWithDefault({
        prod: 'prod',
        default: 'uat',
      }),
      useCdn: true,
      editorUrl: envConf.forEnvWithDefault({
        prod: `https://sanity-cms-sales.rikstv.no`,
        default: `https://sanity-cms-sales.uat.rikstv.no`,
      }),
      apiVersion: '2023-10-21',
    },
    LD_CLIENT_ID: envConf.forEnvWithDefault({
      prod: '6708c551b923000862bf3d98',
      uat: '6708c58254760f0874a43847',
      default: '6708c59830431f083bb4a5bd',
    }),
  };
};
export const appConfig = getConfig();

export type AppConfig = ReturnType<typeof getConfig>;
